module.exports = __webpack_public_path__ + "static/media/undraw_finish_line_katerina_limpitsouni_xy20@2x.e8699718.png";